export default "__VITE_ASSET__f894a1cd__"